// extracted by mini-css-extract-plugin
export default {"sidebar":"phase-sidebar_sidebar__Wh5XO","actions":"phase-sidebar_actions__eaklD","copy":"phase-sidebar_copy__iXqnH","active":"phase-sidebar_active__MUg4n"};